import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/api";

export default function Signup() {
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink px-4" data-testid="signup-page">
      <div className="w-full max-w-md bg-white p-10">
        <Link to="/" className="flex justify-center mb-8"><img src={LOGO} alt="Rock Hard Tennis" className="h-20 w-20 object-contain" /></Link>
        <h1 className="font-display text-3xl uppercase text-center mb-2">Join The Squad</h1>
        <p className="text-center text-sm text-gray-500 mb-8">Create your account</p>
        {error && <p className="bg-sale/10 text-sale text-sm p-3 mb-4 text-center" data-testid="signup-error">{error}</p>}
        <form onSubmit={submit} className="flex flex-col gap-5">
          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Full Name</label>
            <input type="text" required value={name} onChange={(e) => setName(e.target.value)} data-testid="signup-name"
              className="border-b border-gray-300 py-3 text-sm focus:outline-none focus:border-ink transition-colors" />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signup-email"
              className="border-b border-gray-300 py-3 text-sm focus:outline-none focus:border-ink transition-colors" />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signup-password"
              className="border-b border-gray-300 py-3 text-sm focus:outline-none focus:border-ink transition-colors" />
          </div>
          <button type="submit" disabled={loading} className="mt-4 bg-ink text-cream py-4 font-bold uppercase tracking-widest hover:bg-ink/85 transition-colors disabled:opacity-60" data-testid="signup-submit">
            {loading ? "Creating..." : "Create Account"}
          </button>
        </form>
        <p className="text-center text-sm mt-6 text-gray-500">
          Already have an account? <Link to="/login" className="font-bold text-ink hover:text-sale" data-testid="link-login">Log In</Link>
        </p>
      </div>
    </div>
  );
}
